import CloseRedButton from "./images/close-button.png";

import "./customModal.scss";

interface ICustomModal {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className: string;
  fade?: boolean;
}
export const CustomModal = ({
  isOpen,
  onClose,
  children,
  fade,
  className
}: ICustomModal) => {
  if (!isOpen) return null;
  return (
    <div
      className={`custom-modal ${
        fade ? "custom-modal-fade" : ""
      } ${className}`}>
      <div className='custom-modal-overlay' />
      <div className='custom-modal-child'>
        <div className={`custom-modal-child-child`}>
          <div className='custom-modal-close mt-3'>
            <img src={CloseRedButton} alt='' onClick={() => onClose()} />
          </div>
          <div className='custom-modal-content'>{children}</div>
        </div>
      </div>
    </div>
  );
};
